/**
 * Personalization gate — blocks add-to-cart if the name field is empty.
 * Works with any Shopify theme. Add this file to /assets/ and load it
 * from your theme.liquid or product.liquid:
 *   <script src="{{ 'personalization-field.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';

  function init() {
    const wrapper = document.getElementById('personalization-wrapper');
    if (!wrapper) return; // product doesn't require personalization — do nothing

    const input = document.getElementById('personalization-name');
    const errorMsg = document.getElementById('personalization-error');

    // Find the product form — works with most themes
    const form = wrapper.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    // Find the add-to-cart button(s) inside this form
    const addBtns = form.querySelectorAll('[type="submit"], .btn-add-to-cart, #AddToCart, [name="add"]');

    function showError() {
      errorMsg.style.display = 'block';
      input.setAttribute('aria-invalid', 'true');
      input.classList.add('personalization-input--error');
      input.focus();
    }

    function clearError() {
      errorMsg.style.display = 'none';
      input.removeAttribute('aria-invalid');
      input.classList.remove('personalization-input--error');
    }

    // Clear error as soon as the user starts typing
    input.addEventListener('input', clearError);

    // Intercept form submission
    form.addEventListener('submit', function (e) {
      if (input.value.trim() === '') {
        e.preventDefault();
        e.stopImmediatePropagation();
        showError();
        return false;
      }
    });

    // Also intercept button clicks (some themes use fetch/AJAX instead of submit)
    addBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (input.value.trim() === '') {
          e.preventDefault();
          e.stopImmediatePropagation();
          showError();
        }
      }, true); // capture phase so we run before the theme's own handler
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();